export const LOCALLY_STORED_SETTINGS_KEY = 'locallyStoredSettings'
